// features/clients/clientsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import moment from 'moment-timezone';
import axios from 'axios'; 
import { fetchRemovals, fetchDealerRemovals } from '../removals/removalsSlice';
import {
  fetchfullClientsAPI,
  fetchchunkLatestClientsAPI,
  fetchdealerfullClientsAPI,
  fetchofficefullClientsAPI,
  fetchOfficesAPI,
  fetchDevicesAPI,
  fetchdealerDevicesAPI,
  fetchdealerOfficesAPI,
  fetchdealerUsersAPI,
  fetchDriversAPI,
  fetchOLEDDevicesAPI,
  createOLEDDeviceAPI,
  editOLEDDeviceAPI,
  deleteOLEDDeviceAPI,
  getOLEDSerialNumberAPI,
  createfullClientAPI,
  editfullProhibAPI,
  editfullClientAPI,
  deleteFullclientAPI,
  fetchuniquefullClientAPI,
  fetchuniquerInvoice2API,
  createInvoiceAPI,
  controlidfetchLogsAPI,
  getDeviceTimezoneAPI,
  stateTimezones
} from './clientsAPI';

const getUser = () => {
  try {
    const user = localStorage.getItem('admin_user');
    return user ? JSON.parse(user) : null;
  } catch (e) {
    return null;
  }
};

// ==================== ASYNC THUNKS ====================

export const fetchfullClients = createAsyncThunk(
  'clients/fetchfullClients',
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchfullClientsAPI();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch clients');
    }
  }
);

export const fetchchunkLatestClients = createAsyncThunk(
  'clients/fetchchunkLatestClients',
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchchunkLatestClientsAPI();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch chunk clients');
    }
  }
);

export const fetchdealerfullClients = createAsyncThunk(
  'clients/fetchdealerfullClients',
  async (dealerId, { rejectWithValue }) => {
    try {
      const data = await fetchdealerfullClientsAPI(dealerId);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch dealer clients');
    }
  }
);

export const fetchofficefullClients = createAsyncThunk(
  'clients/fetchofficefullClients',
  async (officeId, { rejectWithValue }) => {
    try {
      return await fetchofficefullClientsAPI(officeId);
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch office clients');
    }
  }
);

export const fetchOffices = createAsyncThunk(
  'clients/fetchOffices',
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchOfficesAPI();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch offices');
    }
  }
);

export const fetchDevices = createAsyncThunk(
  'clients/fetchDevices',
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchDevicesAPI();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch devices');
    }
  }
);

export const fetchdealerDevices = createAsyncThunk(
  'clients/fetchdealerDevices',
  async (dealerId, { rejectWithValue }) => {
    try {
      const data = await fetchdealerDevicesAPI(dealerId);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch dealer devices');
    }
  }
);

export const fetchdealerOffices = createAsyncThunk(
  'clients/fetchdealerOffices',
  async (dealerId, { rejectWithValue }) => {
    try {
      const data = await fetchdealerOfficesAPI(dealerId);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch dealer offices');
    }
  }
);

export const fetchdealerUsers = createAsyncThunk(
  'clients/fetchdealerUsers',
  async (dealerId, { rejectWithValue }) => {
    try {
      const data = await fetchdealerUsersAPI(dealerId);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch dealer users');
    }
  }
);

// ==================== NEW: FETCH ALL USERS ====================
export const fetchUsers = createAsyncThunk(
  'clients/fetchUsers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("https://alcobrakeadmin.com/v3/us/causers/getallusers");
      if (response.data != null) {
        return response.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      return rejectWithValue(error.message || 'Failed to fetch users');
    }
  }
);

export const addToRemovals = createAsyncThunk(
  'clients/addToRemovals',
  async ({ item, removalDate }, { dispatch, rejectWithValue }) => {
    try {
      // Step 1: Update prohibend date
      const formData = new FormData();
      formData.append("prohibend", removalDate);
      
      console.log("✅ Updating prohibend with:", removalDate);
      
      await axios.post(
        `https://alcobrakeadmin.com/v3/us/fullclients/updateremovaldate/${item.id}`,
        formData
      );
      
      console.log("✅ Prohibend updated successfully");
      
      // Step 2: Move to removals (download logs first)
      const logsResponse = await axios.get(
        `https://alcobrakeadmin.com/v3/us/fullclients/deletefullclientprohibs/${item.id}`
      );
      
      console.log("✅ Logs API Response:", logsResponse.data);
      
      if (logsResponse.data !== "Success Moving to removals") {
        throw new Error("Logs download failed");
      }
      
      // Step 3: Delete the client
      const deleteResponse = await axios.get(
        `https://alcobrakeadmin.com/v3/us/fullclients/deletefullclient/${item.id}`
      );
      
      if (deleteResponse.data !== "delete success") {
        throw new Error("Delete failed");
      }
      
      console.log("✅ Successfully moved to Removals");
      
      // Step 4: Refresh client list based on role
      const user = getUser() || {};
      if (user.role === "Admin" || user.role === "superadmin") {
        await dispatch(fetchfullClients());
        // await dispatch(fetchchunkLatestClients());
        await dispatch(fetchRemovals());
      } else {
        await dispatch(fetchdealerfullClients(user.dealerId));
        await dispatch(fetchDealerRemovals(user.dealerId));
      }
      
      return { success: true, message: "Successfully Moved to Removals" };
      
    } catch (error) {
      console.error("❌ Error:", error);
      return rejectWithValue(error.message || "Failed to move to removals");
    }
  }
);

export const fetchDrivers = createAsyncThunk(
  'clients/fetchDrivers',
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchDriversAPI();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch drivers');
    }
  }
);

export const fetchOLEDDevices = createAsyncThunk(
  'clients/fetchOLEDDevices',
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchOLEDDevicesAPI();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch OLED devices');
    }
  }
);

export const createOLEDDevice = createAsyncThunk(
  'clients/createOLEDDevice',
  async (formData, { dispatch, rejectWithValue }) => {
    try {
      const response = await createOLEDDeviceAPI(formData);
      await dispatch(fetchOLEDDevices());
      return response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to create OLED device');
    }
  }
);

export const editOLEDDevice = createAsyncThunk(
  'clients/editOLEDDevice',
  async ({ id, devdata }, { dispatch, rejectWithValue }) => {
    try {
      const response = await editOLEDDeviceAPI(id, devdata);
      await dispatch(fetchOLEDDevices());
      return response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to edit OLED device');
    }
  }
);

export const deleteOLEDDevice = createAsyncThunk(
  'clients/deleteOLEDDevice',
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const response = await deleteOLEDDeviceAPI(id);
      await dispatch(fetchOLEDDevices());
      return response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to delete OLED device');
    }
  }
);

export const getOLEDSerialNumber = createAsyncThunk(
  'clients/getOLEDSerialNumber',
  async (state, { rejectWithValue }) => {
    try {
      const data = await getOLEDSerialNumberAPI(state);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to get serial number');
    }
  }
);

export const createfullClient = createAsyncThunk(
  'clients/createfullClient',
  async (formData, { dispatch, rejectWithValue }) => {
    try {
      const response = await createfullClientAPI(formData);
      const user = getUser();
      if (user?.role === "Admin" || user?.role === "superadmin") {
        await dispatch(fetchfullClients());
      } else {
        await dispatch(fetchdealerfullClients(user?.dealerId));
      }
      return response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to create client');
    }
  }
);

export const editfullProhib = createAsyncThunk(
  'clients/editfullProhib',
  async ({ cdata, id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await editfullProhibAPI(id, cdata);
      const user = getUser();
      if (user?.role === "Admin" || user?.role === "superadmin") {
        await dispatch(fetchfullClients());
        // await dispatch(fetchchunkLatestClients());
      } else {
        await dispatch(fetchdealerfullClients(user?.dealerId));
      }
      return response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to edit client');
    }
  }
);

export const editfullClient = createAsyncThunk(
  'clients/editfullClient',
  async ({ cdata, id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await editfullClientAPI(id, cdata);
      const user = getUser();
      if (user?.role === "Admin" || user?.role === "superadmin") {
        await dispatch(fetchfullClients());
        // await dispatch(fetchchunkLatestClients());
      } else {
        await dispatch(fetchdealerfullClients(user?.dealerId));
      }
      return response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to edit client');
    }
  }
);

export const deleteFullclient = createAsyncThunk(
  'clients/deleteFullclient',
  async (clientData, { dispatch, rejectWithValue }) => {
    try {
      const response = await deleteFullclientAPI(clientData);
      const user = getUser();
      if (user?.role === "Admin" || user?.role === "superadmin") {
        await dispatch(fetchfullClients());
        // await dispatch(fetchchunkLatestClients());
      } else {
        await dispatch(fetchdealerfullClients(user?.dealerId));
      }
      return response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to delete client');
    }
  }
);

export const fetchuniquefullClient = createAsyncThunk(
  'clients/fetchuniquefullClient',
  async (clientName, { rejectWithValue }) => {
    try {
      const data = await fetchuniquefullClientAPI(clientName);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch client details');
    }
  }
);

export const fetchuniquerInvoice2 = createAsyncThunk(
  'clients/fetchuniquerInvoice2',
  async (regnum, { rejectWithValue }) => {
    try {
      const data = await fetchuniquerInvoice2API(regnum);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch invoices');
    }
  }
);

export const createInvoice = createAsyncThunk(
  'clients/createInvoice',
  async (invoiceData, { rejectWithValue }) => {
    try {
      const data = await createInvoiceAPI(invoiceData);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to create invoice');
    }
  }
);

// Fetch real-time GPS ping data
export const fetchDevicePing = createAsyncThunk(
  'clients/fetchDevicePing',
  async ({ cbid, devId, isOled }, { rejectWithValue }) => {
    try {
      let url;
      if (isOled) {
        url = `https://alcobrakeadmin.com/v3/app/v2data/getlatestpingv2?devId=${devId}`;
      } else {
        url = `https://alcobrakeadmin.com/v3/app/v2data/getlatestpingv22?cbid=${cbid}`;
      }
      console.log('Fetching ping from:', url);
      const response = await fetch(url);
      const data = await response.json();
      console.log('Ping response:', data);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchDevicePings = createAsyncThunk(
  'clients/fetchDevicePings',
  async ({ cbid, devId, isOled, fromDate, toDate }, { rejectWithValue }) => {
    try {
      let url;
      if (isOled) {
        url = `https://alcobrakeadmin.com/v3/app/v2data/getallpingsv2?devId=${devId}&from=${fromDate}&to=${toDate}`;
      } else {
        url = `https://alcobrakeadmin.com/v3/app/v2data/getallpingsv22?cbid=${cbid}&from=${fromDate}&to=${toDate}`;
      }
      console.log('Fetching pings from:', url);
      const response = await fetch(url);
      const data = await response.json();
      console.log('Pings response:', data);
      return data || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



// Control ID Fetch Logs with full transformation
export const controlidfetchLogs = createAsyncThunk(
  'clients/controlidfetchLogs',
  async ({ item, role, sorted }, { rejectWithValue }) => {
    try {
      const logsData = await controlidfetchLogsAPI(item.cbid, item.installDate, item.id);

      if (!logsData || logsData.length === 0) {
        return [];
      }

      // Fetch Device Timezone logic
      let deviceTimezone = "America/Los_Angeles";
      let ischange = 0;
      
      if (item.sno) {
        try {
          const deviceInfo = await getDeviceTimezoneAPI(item.sno);
          if (deviceInfo) {
            if (deviceInfo.timezone === "GMT") {
              deviceTimezone = stateTimezones[deviceInfo.tagstate] || "GMT";
              ischange = 1;
            } else if (deviceInfo.timezone === "") {
              deviceTimezone = "America/Los_Angeles";
              ischange = 0;
            } else {
              deviceTimezone = deviceInfo.timezone;
              ischange = 0;
            }
          }
        } catch (err) {
          console.warn("Device Not Added in the List or fetch error", err);
        }
      }

      let arr = [...logsData];

      // Filter based on role
      if (role === "superadmin") {
        arr = logsData.filter(o => o.typeofevent !== "0");
      } else {
        arr = logsData.filter(o =>
          o.typeofevent !== "0" &&
          o.typeofevent !== "151" &&
          o.typeofevent !== "152" &&
          o.typeofevent !== "153" &&
          o.typeofevent !== "154" &&
          o.typeofevent !== "155" &&
          o.typeofevent !== "156" &&
          o.typeofevent !== "157" &&
          o.typeofevent !== "218" &&
          o.typeofevent !== "219"
        );
      }

      // Use ID order while transforming and deduplicating records.
      const arr2 = arr.sort((a, b) => Number(a.id || 0) - Number(b.id || 0));

      // Filter for office role
      const repdata = arr2.reverse().filter(
        e => !(role === "office" && [19, 22, 6, 7, 65, 66, 21, 4, 17, 18, 24, 28, 29, 34, 25, 27, 8, 11, 60, 61, 14, 62, 10, 20, 217, 219, 218, 151, 152, 153, 154, 155, 156, 157, 225, 28, 220, 221, 222, 223, 224, 225, 226, 227, 56, 101].includes(Number(e.typeofevent)))
      );

      const newArr = [];

      repdata.forEach(element => {
        if (element.typeofevent === "29" || element.typeofevent === "56") {
          return;
        }

        let eventType = "";
        let Result = "";
        let Bacvalue = "";

        // Event type mapping
        if (element.typeofevent == 254) {
          if (element.randominitial == 2 || element.randominitial == 0) {
            eventType = "INITIAL TEST";
          } else if (element.randominitial == 3 || element.randominitial == 1) {
            eventType = "RANDOM TEST";
          } else {
            eventType = "NA";
          }
          Result = element.passfailstatus == 1 ? "PASS" : (element.passfailstatus == 0 ? "FAIL" : " ");
        } else if (element.typeofevent == 15) {
          eventType = element.enginerunstate == 0 ? "ENGINE OFF" : (element.enginerunstate == 1 ? "ENGINE ON" : "NA");
        } else if (element.typeofevent == 65) {
          eventType = "INSUFFICIENTVOLUME";
        } else if (element.typeofevent == 66) {
          eventType = "HARD_BLOW";
        } else if (element.typeofevent == 21) {
          eventType = "CAR_BATTERY_TAMPERING";
        } else if (element.typeofevent == 19) {
          eventType = "VIOLATION_LOCKOUT";
        } else if (element.typeofevent == 4) {
          eventType = "BYPASS";
        } else if (element.typeofevent == 18) {
          eventType = "TEST_REFUSED_RR_TEST";
        } else if (element.typeofevent == 17) {
          eventType = "INSUFFICIENTVOLUME_3";
        } else if (element.typeofevent == 24) {
          eventType = "TEST_REFUSED_RR_TEST_3";
        } else if (element.typeofevent == 28) {
          eventType = "TAMPERED";
        } else if (element.typeofevent == 22) {
          eventType = "CALIBRATION DONE";
        } else if (element.typeofevent == 34) {
          eventType = "ENGINE_NOT_STARTED";
        } else if (element.typeofevent == 27) {
          eventType = "COOL_SAMPLE";
        } else if (element.typeofevent == 25) {
          eventType = "HOT_SAMPLE";
        } else if (element.typeofevent == 8) {
          eventType = "ONE_TIME_PASS_CODE";
        } else if (element.typeofevent == 6) {
          eventType = "SERVICE_PERIOD_SET";
        } else if (element.typeofevent == 7) {
          eventType = "VIOLATION_RESET";
        } else if (element.typeofevent == 11) {
          eventType = "LOG_READ";
        } else if (element.typeofevent == 220) {
          eventType = "LOCKOUT 0";
        } else if (element.typeofevent == 221) {
          eventType = "LOCKOUT 1";
        } else if (element.typeofevent == 222) {
          eventType = "LOCKOUT 2";
        } else if (element.typeofevent == 223) {
          eventType = "LOCKOUT 3";
        } else if (element.typeofevent == 224) {
          eventType = "LOCKOUT 4";
        } else if (element.typeofevent == 225) {
          eventType = "LOCKOUT 5";
        } else if (element.typeofevent == 226) {
          eventType = "LOCKOUT 6";
        } else if (element.typeofevent == 227) {
          eventType = "LOCKOUT 7";
        } else if (element.typeofevent == 100) {
          eventType = "Emergency_SOS";
        } else if (element.typeofevent == 101) {
          eventType = "PICTURE_CAPTURED";
        } else if (element.typeofevent == 60) {
          eventType = "BYPASS_START";
        } else if (element.typeofevent == 61) {
          eventType = "BYPASS_STOP";
        } else if (element.typeofevent == 14) {
          eventType = "SERVICE_ALERT";
        } else if (element.typeofevent == 62) {
          eventType = "SAMPLER_DISCONNECTED";
        } else if (element.typeofevent == 10) {
          eventType = "CAR_BATTERY_OFF";
        } else if (element.typeofevent == 20) {
          eventType = "CAR_BATTERY_ON";
        } else if (element.typeofevent == 217) {
          eventType = "MEMSET";
        } else if (element.typeofevent == 219) {
          eventType = "TIME_SET";
        } else if (element.typeofevent == 218) {
          eventType = "DEVICE RESTART";
        } else if (element.typeofevent == 151) {
          eventType = "ALCOHOL_SENSOR_FAIL";
        } else if (element.typeofevent == 152) {
          eventType = "BREATH_PRESSURE_SEN_FAIL";
        } else if (element.typeofevent == 153) {
          eventType = "BREATH_TEMP_SEN_FAIL";
        } else if (element.typeofevent == 154) {
          eventType = "BMP180_ALTITUDE_FAIL";
        } else if (element.typeofevent == 155) {
          eventType = "PROXIMITY_SENSOR_FAIL";
        } else if (element.typeofevent == 156) {
          eventType = "TMP75_AMB_TEMP_SENS_FAIL";
        } else if (element.typeofevent == 157) {
          eventType = "RTC_FAIL";
        } else if (element.typeofevent == 111) {
          eventType = "Handset_Changed";
        } 
      if (element.typeofevent == 41) {
  eventType = `OTP_${element.bacvalue}_1`;
}

else if (element.typeofevent == 42) {
  eventType = `OTP_${element.bacvalue}_2`;
}

else if (element.typeofevent == 43) {
  eventType = `OTP_${element.bacvalue}_3`;
}

else if (element.typeofevent == 44) {
  eventType = `OTP_${element.bacvalue}_4`;
} 
        else if (element.typeofevent == 1) {
          eventType = "Powered_on";
        }

        // Calculate BAC
        if (element.bacvalue != 255 && element.bacvalue) {
          Bacvalue = (parseFloat(element.bacvalue) / 1000).toFixed(3);
        } else {
          Bacvalue = "";
        }

        // Convert time
        let convertedDateTime = element.rtime;
        if (element.controlId === "ABC_c4_dd_57_8c_a4_9c") {
          const distTime = moment(element.created_at).format('MM/DD/YYYY HH:mm:ss');
          convertedDateTime = moment.utc(distTime, 'MM/DD/YYYY HH:mm:ss').tz("America/Los_Angeles").format('MM/DD/YYYY HH:mm:ss');
        } else if (String(item.devicemode || item.deviceMode || '').trim().toUpperCase() === "A300I") {
          convertedDateTime = element.rtime;
        } else if (ischange === 1) {
          convertedDateTime = moment.utc(element.rtime, 'MM/DD/YYYY HH:mm:ss').tz(deviceTimezone).format('MM/DD/YYYY HH:mm:ss');
        } else {
          convertedDateTime = element.rtime;
        }
        // The API stores the event environmental values as a comma-separated
        // string in `vbat`: pressure offset, alcohol offset, ambient
        // temperature, altitude, and battery voltage.
        const vbatValues = typeof element.vbat === "string" && element.vbat !== "NA"
          ? element.vbat.split(",").map(value => value.trim())
          : [];
        // Engine events can contain only a hyphen-separated Row ID packet,
        // without the comma-separated environmental fields.
        const environmentalValues = String(element.typeofevent).trim() === '15' && vbatValues.length === 1
          ? []
          : vbatValues;
 
        const obj = {
          id: element.id,
          bacvalue: Bacvalue,
          rtime: convertedDateTime,
          devid: element.devid,
          controlId: element.controlId,
          passfailstatus: Result,
          typeofevent: eventType,
          rawEventType: String(element.typeofevent ?? '').trim(),
          rawVbat: element.vbat,
          vbat: element.vbat == "NA" ? " " : vbatValues,
          pressureOffset: environmentalValues[0] || "",
          alcoholOffset: environmentalValues[1] || "",
          ambTemperature: environmentalValues[2] || "",
          altitude: environmentalValues[4] || "",
          imgtime: element.rtime,
          // Legacy keys for compatibility
          samplerId: element.devid || "",
          time: convertedDateTime,
          event: eventType,
          bac: Bacvalue,
          result: Result,
          image: element.imgtime || element.rtime,
          rawRtime: element.rtime
        };

        const exists = newArr.some(existingItem =>
          existingItem.controlId === obj.controlId &&
          existingItem.rtime === obj.rtime &&
          existingItem.typeofevent === obj.typeofevent
        );

        if (!exists) {
          newArr.push(obj);
        }
      });

      // Filter by install date
      let filteredLogs = newArr;
      if (item.installDate) {
        const installMoment = moment(item.installDate, "MM/DD/YYYY");
        if (installMoment.isValid()) {
          filteredLogs = newArr.filter(e =>
            moment(e.rtime, "MM/DD/YYYY HH:mm:ss").isSameOrAfter(installMoment, 'day')
          );
        }
      }

      // Sort after timezone conversion so the visible event times stay in order.
      // Recent mode keeps the descending ID order established above.
      if (!sorted) {
        const eventTime = log => {
          const parsed = moment(log.rtime, ['MM/DD/YYYY HH:mm:ss', moment.ISO_8601], true);
          return parsed.isValid() ? parsed.valueOf() : -Infinity;
        };
        filteredLogs.sort((a, b) => {
          const aTime = eventTime(a);
          const bTime = eventTime(b);
          if (aTime !== bTime) return aTime > bTime ? -1 : 1;
          return Number(b.id || 0) - Number(a.id || 0);
        });
      }

      return filteredLogs;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch logs');
    }
  }
);

// ==================== SLICE ====================

const clientsSlice = createSlice({
  name: 'clients',
  initialState: {
    fullclients: [],
    offices: [],
    devices: [],
    users: [],
    dealerOffices: [],
    drivers: [],
    oledDevices: [],
    uniqueInvoice2: [],
    uniqueClient: null,
    logs: [],
    loading: false,
    error: null,
    successMessage: null,
    totalRecords: 0,
    logsLoading: false,
    logsError: null,
    gpsData: null,
    gpsHistory: [],
    gpsLoading: false,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.successMessage = null;
    },
    clearLogs: (state) => {
      state.logs = [];
    },
    clearLogsError: (state) => {
      state.logsError = null;
    },
    clearUniqueClient: (state) => {
    state.uniqueClient = null;
  }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchfullClients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchfullClients.fulfilled, (state, action) => {
        state.loading = false;
        state.fullclients = action.payload;
        state.totalRecords = action.payload?.length || 0;
      })
      .addCase(fetchfullClients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchchunkLatestClients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchchunkLatestClients.fulfilled, (state, action) => {
        state.loading = false;
        state.fullclients = action.payload;
        state.totalRecords = action.payload?.length || 0;
      })
      .addCase(fetchchunkLatestClients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchdealerfullClients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchdealerfullClients.fulfilled, (state, action) => {
        state.loading = false;
        state.fullclients = action.payload;
        state.totalRecords = action.payload?.length || 0;
      })
      .addCase(fetchdealerfullClients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchofficefullClients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchofficefullClients.fulfilled, (state, action) => {
        state.loading = false;
        state.fullclients = action.payload;
        state.totalRecords = action.payload?.length || 0;
      })
      .addCase(fetchofficefullClients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchOffices.fulfilled, (state, action) => {
        state.offices = action.payload;
      })
      .addCase(fetchDevices.fulfilled, (state, action) => {
        state.devices = action.payload;
      })
      .addCase(fetchdealerDevices.fulfilled, (state, action) => {
        state.devices = action.payload;
      })
      .addCase(fetchdealerOffices.fulfilled, (state, action) => {
        state.dealerOffices = action.payload;
      })
      .addCase(fetchdealerUsers.fulfilled, (state, action) => {
        state.users = action.payload;
      })
      // NEW: fetchUsers reducer
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.users = action.payload;
      })
      .addCase(fetchDrivers.fulfilled, (state, action) => {
        state.drivers = action.payload;
      })
      .addCase(fetchOLEDDevices.fulfilled, (state, action) => {
        state.oledDevices = action.payload;
      })
      .addCase(createOLEDDevice.fulfilled, (state) => {
        state.successMessage = 'OLED Device added successfully!';
      })
      .addCase(editOLEDDevice.fulfilled, (state) => {
        state.successMessage = 'OLED Device updated successfully!';
      })
      .addCase(deleteOLEDDevice.fulfilled, (state) => {
        state.successMessage = 'OLED Device deleted successfully!';
      })
      .addCase(fetchuniquerInvoice2.fulfilled, (state, action) => {
        state.uniqueInvoice2 = action.payload;
      })
      .addCase(fetchuniquefullClient.fulfilled, (state, action) => {
  state.uniqueClient = action.payload;
})
.addCase(fetchuniquefullClient.rejected, (state) => {
  state.uniqueClient = null;
})

      .addCase(controlidfetchLogs.pending, (state) => {
        state.logsLoading = true;
        state.logsError = null;
      })
      .addCase(controlidfetchLogs.fulfilled, (state, action) => {
        state.logsLoading = false;
        state.logs = action.payload;
      })
      .addCase(controlidfetchLogs.rejected, (state, action) => {
        state.logsLoading = false;
        state.logsError = action.payload;
      })
      .addCase(createfullClient.fulfilled, (state) => {
        state.successMessage = 'Client created successfully!';
      })
      .addCase(editfullProhib.fulfilled, (state) => {
        state.successMessage = 'Client updated successfully!';
      })
      .addCase(editfullClient.fulfilled, (state) => {
        state.successMessage = 'Client updated successfully!';
      })
      .addCase(deleteFullclient.fulfilled, (state) => {
        state.successMessage = 'Client removed successfully!';
      })
      .addCase(createInvoice.fulfilled, (state) => {
        state.successMessage = 'Invoice created successfully!';
      })
      .addCase(fetchDevicePing.pending, (state) => {
        state.gpsLoading = true;
      })
      .addCase(fetchDevicePing.fulfilled, (state, action) => {
        state.gpsLoading = false;
        state.gpsData = action.payload;
      })
      .addCase(fetchDevicePing.rejected, (state) => {
        state.gpsLoading = false;
        state.gpsData = null;
      })
      .addCase(fetchDevicePings.pending, (state) => {
        state.gpsLoading = true;
      })
      .addCase(fetchDevicePings.fulfilled, (state, action) => {
        state.gpsLoading = false;
        state.gpsHistory = action.payload;
      })
      .addCase(fetchDevicePings.rejected, (state) => {
        state.gpsLoading = false;
        state.gpsHistory = [];
      });
  }
});


export const { clearError, clearSuccess, clearLogs, clearLogsError, clearUniqueClient} = clientsSlice.actions;

export const selectFullClients = (state) => state.clients.fullclients;
export const selectOffices = (state) => state.clients.offices;
export const selectDevices = (state) => state.clients.devices;
export const selectUsers = (state) => state.clients.users;
export const selectDealerOffices = (state) => state.clients.dealerOffices;
export const selectDrivers = (state) => state.clients.drivers;
export const selectOledDevices = (state) => state.clients.oledDevices;
export const selectUniqueInvoice2 = (state) => state.clients.uniqueInvoice2;
export const selectUniqueClient = (state) => state.clients.uniqueClient;
export const selectClientLogs = (state) => state.clients.logs;
export const selectLogsLoading = (state) => state.clients.logsLoading;
export const selectLogsError = (state) => state.clients.logsError;
export const selectClientsLoading = (state) => state.clients.loading;
export const selectClientsError = (state) => state.clients.error;
export const selectClientsSuccess = (state) => state.clients.successMessage;
export const selectTotalRecords = (state) => state.clients.totalRecords;

export default clientsSlice.reducer;
